module.exports = __webpack_public_path__ + "img/355-7d496e.png";